import script from "./MallHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MallHeader.vue?vue&type=script&setup=true&lang=js"

import "./MallHeader.vue?vue&type=style&index=0&id=5740d13f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5740d13f"]])

export default __exports__